import { MindmapPaletteColors, MindmapPaletteThemeColor } from "./mindmap-theme";
import { MINDMAP_COLOR_BLACK_DIRTY, MINDMAP_COLOR_WHITE } from "./theme-constants";

export const DEFAULT_PALETTE_COLOR: MindmapPaletteThemeColor = {
	color: MINDMAP_COLOR_BLACK_DIRTY,
	contrast: MINDMAP_COLOR_WHITE,
	name: "Black"
};

export const MINDMAP_THEME_PALETTE_COLORS_ENERGY: MindmapPaletteColors = [
	{ color: "#E57373", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#BA68C8", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#9575CD", contrast: MINDMAP_COLOR_WHITE, name: "Violet" },
	{ color: "#818CF8", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#60A5FA", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#4DD0E1", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#2bc28c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Teal" },
	{ color: "#059669", contrast: MINDMAP_COLOR_WHITE, name: "Green" },
	{ color: "#AED581", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Green" },
	{ color: "#E2E05D", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lime" },
	{ color: "#FCD34D", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#FFA500", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#A52A2A", contrast: MINDMAP_COLOR_WHITE, name: "Brown" }
];

/*export const MINDMAP_THEME_PALETTE_COLORS_GOOGLE: MindmapPaletteColors = [
	{ color: "#EF5350", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#EC407A", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#AB47BC", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#7E57C2", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#5C6BC0", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#42A5F5", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#26C6DA", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#26A69A", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#66BB6A", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#9CCC65", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#D4E157", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FFEE58", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FFCA28", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FFA726", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FF7043", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#8D6E63", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#BDBDBD", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#78909C", contrast: MINDMAP_COLOR_WHITE }
];*/

export const MINDMAP_THEME_PALETTE_COLORS_PASTEL: MindmapPaletteColors = [
	{ color: "#ffadad", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#ffd6a5", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#fdffb6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#caffbf", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#9bf6ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#a0c4ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Indigo" },
	{ color: "#bdb2ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Violet" },
	{ color: "#ffc6ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pink" }
];

export const THEME_PALETTE_COLORS_CANDY: MindmapPaletteColors = [
	{ color: "#ba88ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Purple" },
	{ color: "#ff78c7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pink" },
	{ color: "#fee440", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#00bbf9", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#00f5d4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" }
];

export const MINDMAP_THEME_PALETTE_COLORS_RUST: MindmapPaletteColors = [
	{ color: "#053047", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#005f73", contrast: MINDMAP_COLOR_WHITE, name: "Teal" },
	{ color: "#0a9396", contrast: MINDMAP_COLOR_WHITE, name: "Cyan" },
	{ color: "#94d2bd", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Cyan" },
	{ color: "#e9d8a6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Yellow" },
	{ color: "#ee9b00", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#ca6702", contrast: MINDMAP_COLOR_WHITE, name: "Dark Orange" },
	{ color: "#bb3e03", contrast: MINDMAP_COLOR_WHITE, name: "Brown" },
	{ color: "#ae2012", contrast: MINDMAP_COLOR_WHITE, name: "Dark Red" },
	{ color: "#9b2226", contrast: MINDMAP_COLOR_WHITE, name: "Teal" }
];

export const MINDMAP_THEME_PALETTE_COLORS_BRIGHT: MindmapPaletteColors = [
	{ color: "#5aa9e6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#7fc8f8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Blue" },
	{ color: "#ffe45e", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#ff6392", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" }
];

export const MINDMAP_THEME_PALETTE_COLORS_FOREST: MindmapPaletteColors = [
	{ color: "#304f65", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#fe7f2d", contrast: MINDMAP_COLOR_WHITE, name: "Orange" },
	{ color: "#fcca46", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#a1c181", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Green" },
	{ color: "#619b8a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Dark Green" }
];

export const MINDMAP_THEME_PALETTE_COLORS_WAVES: MindmapPaletteColors = [
	{ color: "#023e8a", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#0077b6", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#0096c7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Blue" },
	{ color: "#00b4d8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#48cae4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Cyan" },
	{ color: "#90e0ef", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sky Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_NATURE: MindmapPaletteColors = [
	{ color: "#ef476f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#ffd166", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#06d6a0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#118ab2", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#073b4c", contrast: MINDMAP_COLOR_WHITE, name: "Teal" }
];

export const MINDMAP_THEME_PALETTE_COLORS_NOSTALGIA: MindmapPaletteColors = [
	{ color: "#264653", contrast: MINDMAP_COLOR_WHITE, name: "Teal" },
	{ color: "#2a9d8f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#e9c46a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#f4a261", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#e76f51", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" }
];

export const MINDMAP_THEME_PALETTE_COLORS_GLOW: MindmapPaletteColors = [
	{ color: "#355070", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#6d597a", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#b56576", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#e56b6f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#eaac8b", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MURKY: MindmapPaletteColors = [
	{ color: "#99d98c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Green" },
	{ color: "#76c893", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#52b69a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Teal" },
	{ color: "#34a0a4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#168aad", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#1a759f", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#1e6091", contrast: MINDMAP_COLOR_WHITE, name: "Ocean Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_FIRE: MindmapPaletteColors = [
	{ color: "#f7b267", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Orange" },
	{ color: "#f79d65", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#f4845f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Dark Orange" },
	{ color: "#f27059", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red Orange" },
	{ color: "#f25c54", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" }
];

export const MINDMAP_THEME_PALETTE_COLORS_VACATION: MindmapPaletteColors = [
	{ color: "#2364aa", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#3da5d9", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Blue" },
	{ color: "#73bfb8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#fec601", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#ea7317", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" }
];
